module.exports = __webpack_public_path__ + "static/media/shapes-square.50cf53b6.svg";